import * as React from 'react';
import {styled, styledDiv} from '@packages/utilities/styled';
import {pixel} from '@packages/utilities/inline-style-utils';
import OneLiner from '../OneLiner';

export type ItemProps = React.HTMLAttributes<HTMLElement> & {
  active?: boolean;
  activeBackground?: string;
  background?: string;
  danger?: boolean;
  depth?: number;
  hover?: boolean;
  hoverBackground?: string;
};

const StyledItem: React.ComponentType<ItemProps> = styledDiv(
  ({
    theme: {gutters, control, colors},
    background = colors.background,
    style,
  }) => ({
    // Note! changing these styles requires changing the manual width calculations in NavigatorUtils computeNodeWidth
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    paddingRight: gutters.normal,
    paddingLeft: gutters.normal,
    lineHeight: pixel(control.height),
    background,
    ...style,
  }),
  {
    hover: ({theme, hoverBackground = theme.list.itemBackgroundHover}) => ({
      color: theme.colors.foregroundVivid,
      background: hoverBackground,
    }),
    active: ({theme, activeBackground = theme.colors.accentBackground}) => ({
      color: theme.colors.foregroundVivid,
      background: activeBackground,
    }),
    danger: ({theme}) => ({
      color: theme.colors.foregroundVivid,
      background: theme.colors.dangerBackground,
    }),
  }
);

export const Item = React.forwardRef<any, any>((props, ref) => {
  const {depth, ...rest} = props;
  return (
    <StyledItem
      data-legacy-ds="ListItem"
      ref={ref}
      data-depth={depth}
      {...rest}
    />
  );
});

export const Icon = styledDiv(({theme: {list}}) => ({
  width: list.gridBase,
  height: list.itemHeight,
}));

export const Label = styled(OneLiner)({flex: 1});
